import React from 'react';

export const SpodialIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 636 638'
            fill='none'
        >
            <path
                d='M0 319C0 143.584 142.203 0 317.619 0C493.035 0 635.238 143.584 635.238 319C635.238 494.416 493.035 638 317.619 638C142.203 638 0 494.416 0 319Z'
                fill='#6257D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M385.622 157.646C363.35 205.52 332.893 249.119 295.628 286.471L161.025 421.389C156.806 425.594 161.956 432.519 167.204 429.62L185.789 418.866C186.528 418.438 187.274 419.412 186.67 420.017L118.262 488.585C113.85 492.935 119.297 499.836 124.447 496.839L159.45 476.499C160.189 476.069 160.936 477.044 160.332 477.649L142.53 495.481C138.247 499.773 143.613 506.666 148.772 503.678L228.949 457.264C260.027 439.273 297.772 439.446 333.661 439.446C416.157 439.446 483.033 372.375 483.033 289.638C483.033 268.715 478.769 248.802 471.034 230.707C469.973 228.226 471.022 225.319 473.464 224.182L517.659 203.603C517.686 203.591 517.704 203.564 517.705 203.534C517.706 203.504 517.724 203.478 517.75 203.465C519.905 202.377 520.101 199.288 517.908 197.976L496.998 185.871C495.425 184.961 494.506 183.247 494.495 181.426C494.303 150.178 468.916 124.604 437.39 124.604C414.479 124.604 394.725 138.125 385.622 157.646Z'
                fill='#F4F0FF'
            />
        </svg>
    );
};
